<template>
  <div id="main-dashboard">
    <div id="dashboard-container">
      <div id="dashboard-body">
        <div class="ui container dashboard-info">
          <div class="green-header"  style="position:relative">
            <span class="modal-title">{{ $t('views.secure.changePassword.Title') }}</span>
          </div>
          <div class="ui grid stackable main_container">
            <div class="sixteen wide column">
              <br/>
              <div class="ui form">
                <div class="field">
                  <label>{{ $t('views.secure.changePassword.Contrasenia_actual') }}</label>
                  <input type="password" v-model="currentPassword">
                </div>
                <div class="field">
                  <label>{{ $t('views.secure.changePassword.Nueva_contrasenya') }}</label>
                  <input type="password" v-model.number="newPassword">
                </div>
                <div class="field">
                  <label>{{ $t('views.secure.changePassword.Repetir_nueva_contrasenya') }}</label>
                  <input type="password" v-model="repeatNewPassword">
                </div>
              </div>
              <br/>
              <div class="ui right floated small olive labeled icon button"  @click="save()">
                <i class="checkmark icon"></i> {{$t("components.common.Guardar")}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from '../../utils/axios-general';
import * as CryptoJS from 'crypto-js';

export default {
  name: 'changepassword',
  data: function () {
    return {
      currentPassword: '',
      newPassword: '',
      repeatNewPassword: ''
    };
  },
  methods: {
    save: function () {
      if (this.currentPassword == null || this.currentPassword.length === 0 ||
          this.newPassword == null || this.newPassword.length === 0 ||
          this.repeatNewPassword == null || this.repeatNewPassword.length === 0) {

        this.$swal.fire({ type: 'error', title: this.$i18n.t('views.secure.changePassword.Contrasenyas_invalidas') });
        return;
      }

      /*if (!(/[A-Z]+/.test(this.newPassword))) {
        this.$swal.fire({ type: 'error', title: this.$i18n.t('views.secure.changePassword.Contrasenya_no_segura') });
        return;
      }

      if (!(/[0-9]+/.test(this.newPassword))) {
        this.$swal.fire({ type: 'error', title: this.$i18n.t('views.secure.changePassword.Contrasenya_no_segura') });
        return;
      }*/

      if (this.newPassword.length < 8) {
        this.$swal.fire({ type: 'error', title: this.$i18n.t('views.secure.changePassword.Contrasenyas_no_iguales') });
        return;
      }

      if (this.newPassword !== this.repeatNewPassword) {
        this.$swal.fire({ type: 'error', title: this.$i18n.t('views.secure.changePassword.Contrasenyas_no_iguales') });
        return;
      }

      const hashedCurrentPassword = CryptoJS.SHA256(this.currentPassword).toString(CryptoJS.enc.Base64);
      const hashedNewPassword = CryptoJS.SHA256(this.newPassword).toString(CryptoJS.enc.Base64);

      axios.put('/changepassword', { userId: this.$store.state.user.id, currentPassword: hashedCurrentPassword, newPassword: hashedNewPassword }).then(response => {
        this.$swal.fire(
          this.$i18n.t('views.secure.changePassword.Save_Ok_Title'),
          this.$i18n.t('views.secure.changePassword.Save_Ok_Text'),
          'success'
        );
        this.$router.push({ name: 'home' });
      })
      .catch(e => {
        if (e.response.status === 400 || e.response.status === 403 || e.response.status === 404) {
          this.$swal.fire({
            type: 'error',
            title: this.$i18n.t('views.secure.changePassword.Save_Error'),
            text: this.$i18n.t('views.secure.changePassword.Hay_un_error_actualizar_contrasenya_' + e.response.status)
          });
        } else {
          this.$swal.fire({
            type: 'error',
            title: this.$i18n.t('views.secure.changePassword.Save_Error'),
            text: e
          });
        }
      });
    }
  }
};
</script>
